export enum ScreenSize {
    Small,
    Medium,
    Large,
    XLarge,
    XXLarge
}
